import { useNavigate } from 'react-router'

import authService from '~/@common/services/auth.service'
import modalService from '~/@common/services/modal.service'
import Modal from '~/@common/ui/modal/Modal'
import { getEntrancePage } from '~/@common/utils/getEntrancePage'

const DailyLearningTimeoutModal = () => {
  const navigate = useNavigate()
  return (
    <Modal.Alert
      confirm={{
        style: {
          width: '212px',
        },
        children: <div>홈 화면으로 이동하기</div>,
        onClick: () => {
          navigate(getEntrancePage(authService.userType))
          modalService.closeModal()
        },
      }}
    >
      <p
        style={{
          textAlign: 'center',
        }}
      >
        <>
          학습 시간이 종료되었습니다.
          <br />
          지금까지 학습한 내용들은 저장되지 않습니다.
        </>
      </p>
    </Modal.Alert>
  )
}

export default DailyLearningTimeoutModal

export const openDailyLearningTimeoutModal = () => {
  modalService.openModal(<DailyLearningTimeoutModal />, {
    modalName: 'DailyLearningTimeoutModal',
  })
}
